module.exports = __webpack_public_path__ + "img/arrow-big.26e5a7aa.svg";